import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { isNativePlatform } from "@/utils/nativePlugins";

/**
 * Intercepts marketing routes on native platforms and redirects to /
 * so RootRedirect can handle proper native routing flow.
 */
const NativeEntryGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasChecked = useRef(false);

  useEffect(() => {
    // Only run once per mount
    if (hasChecked.current) return;
    hasChecked.current = true;

    const isNative = isNativePlatform();
    const path = location.pathname;

    // Marketing routes that native users should never see
    const marketingRoutes = ["/seller", "/buyer"];
    const isMarketingRoute = marketingRoutes.includes(path);

    console.log("[NativeEntryGuard] Check:", { isNative, path, isMarketingRoute });

    if (isNative && isMarketingRoute) {
      console.log("[NativeEntryGuard] Redirecting native user from marketing route to /");
      navigate("/", { replace: true });
    }
  }, [navigate, location.pathname]);

  return null;
};

export default NativeEntryGuard;
